module.exports = __webpack_public_path__ + "static/aircrafts.2e809315.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/aircrafts.svg
// module id = 983
// module chunks = 101932004231744